var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "49",
      "height": "49"
    }
  }, _vm.$listeners), [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#005149",
      "d": "M24.5 0C38.03 0 49 10.97 49 24.5S38.03 49 24.5 49 0 38.03 0 24.5 10.97 0 24.5 0"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M39 15.605a11.2 11.2 0 0 1-3.182.875 5.54 5.54 0 0 0 2.433-3.076 11 11 0 0 1-3.515 1.347 5.524 5.524 0 0 0-7.827-.244 5.57 5.57 0 0 0-1.747 4.045q.003.64.141 1.268a15.73 15.73 0 0 1-11.414-5.774 5.57 5.57 0 0 0 1.7 7.395 5.54 5.54 0 0 1-2.512-.694v.074a5.55 5.55 0 0 0 4.446 5.443c-.817.22-1.67.253-2.502.095a5.54 5.54 0 0 0 5.17 3.858A11.1 11.1 0 0 1 12 32.504 15.6 15.6 0 0 0 20.504 35c10.203 0 15.751-8.462 15.751-15.8v-.722A11.3 11.3 0 0 0 39 15.605"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }